import gql from "graphql-tag";

export const {
  users,
  roles,
  news,
  userLogin,
  getUserById,
  getNewsById,
  getRoleById,
} = {
  users: gql`
    query {
      users {
        id
        userName
        createdAt
        isActive
        role {
          id
          roleName
        }
        fullName
        email
      }
    }
  `,
  roles: gql`
    query {
      roles {
        id
        roleName
        createdAt
      }
    }
  `,
  news: gql`
    query {
      news {
        id
        title
        content
        createdAt
        updatedAt
        isDeleted
        author {
          id
          userName
        }
        image
      }
    }
  `,
  userLogin: gql`
    query userLogin($userName: String!, $password: String!) {
      userLogin(userName: $userName, password: $password) {
        success
        token
        msg
      }
    }
  `,
  getUserById: gql`
    query getUserById($userId: ID!) {
      getUserById(userId: $userId) {
        id
        userName
        password
        createdAt
        isActive
        role {
          id
          roleName
        }
        fullName
        email
      }
    }
  `,
  getNewsById: gql`
    query getNewsById($newsId: ID!) {
      getNewsById(newsId: $newsId) {
        id
        title
        content
        isDeleted
        updatedAt
        createdAt
        author {
          id
          userName
        }
        image
      }
    }
  `,
  getRoleById: gql`
    query getRoleById($roleId: ID!) {
      getRoleById(roleId: $roleId) {
        id
        roleName
        createdAt
      }
    }
  `,
};
